import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCertificate, FaExternalLinkAlt } from 'react-icons/fa';
import BlurFade from '../ui/BlurFade';
import { certifications } from '../../data/certifications';

const CertCard = ({ cert }) => (
  <motion.div
    whileHover={{ y: -3, scale: 1.02 }}
    transition={{ type: 'spring', stiffness: 300, damping: 22 }}
    className="flex h-full items-center gap-3 rounded-xl border-2 border-black px-4 py-3"
  >
    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-black text-white">
      <FaCertificate size={13} />
    </span>
    <span className="text-sm font-semibold sm:text-base">{cert.title}</span>
    {cert.fileUrl && <FaExternalLinkAlt size={11} className="ml-auto shrink-0 text-black/40" />}
  </motion.div>
);

const Certifications = () => {
  return (
    <section id="certifications" className="bg-white py-20 text-black">
      <div className="mx-auto max-w-4xl px-6">
        <div className="mb-10 flex flex-wrap items-end justify-between gap-3">
          <BlurFade>
            <h2 className="text-2xl font-black sm:text-3xl">
              Certifications <span className="text-black/30">&amp; Courses</span>
            </h2>
          </BlurFade>
          <BlurFade delay={0.05}>
            <Link to="/certificates" className="text-sm font-semibold underline hover:text-black/70">
              View all certificates &rarr;
            </Link>
          </BlurFade>
        </div>

        <div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2">
          {certifications.map((cert, i) => (
            <BlurFade key={cert.title} delay={(i % 6) * 0.04} className="h-full">
              {cert.fileUrl ? (
                <a href={cert.fileUrl} target="_blank" rel="noopener noreferrer" className="block h-full">
                  <CertCard cert={cert} />
                </a>
              ) : (
                <CertCard cert={cert} />
              )}
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
